import styled from "styled-components";
import { ReactSVG } from "react-svg";

import linkedinSvg from "../../assets/media/icons/linkedin.svg";
import whatsappSvg from "../../assets/media/icons/whatsapp.svg";
import twitterSvg from "../../assets/media/icons/twitter.svg";

const sharePlatformsData = [
  {
    key: "twitter",
    link: "https://twitter.com/intent/tweet?url=#url",
    icon: twitterSvg,
  },
  {
    key: "linkedin",
    link: "https://www.linkedin.com/sharing/share-offsite/?url=#url",
    icon: linkedinSvg,
  },
  {
    key: "whatsapp",
    link: "https://api.whatsapp.com/send?text=#url",
    icon: whatsappSvg,
  },
];

const ContentSharer = ({ url }) => {
  return (
    <Container className="d-flex flex-row align-items-center justify-content-center">
      {sharePlatformsData.map((item, index) => (
        <a
          key={item.key + index + "*"}
          href={item.link.replace("#url", url)}
          target="_blank"
          rel="noreferrer"
        >
          <ReactSVG src={item.icon || null} />
        </a>
      ))}
    </Container>
  );
};

export default ContentSharer;

const Container = styled.div`
  a + a {
    margin-right: 1rem;
  }

  a svg {
    border-radius: 50%;

    .background {
      fill: #fff;
    }
  }
`;
